import { createFileRoute } from '@tanstack/react-router'

import Connections from '@/features/services/pages/connections'

export const Route = createFileRoute('/_shell/connections')({ component: Connections })
